import {CertificateDynamicInputType} from "../../formability/certificateBuilder/enums/certificateDynamicInputType";

export const DynamicInputTypes = [
  CertificateDynamicInputType.Text,
  CertificateDynamicInputType.Image,
  CertificateDynamicInputType.Repeatable,
  CertificateDynamicInputType.Object,
  CertificateDynamicInputType.Number,
  CertificateDynamicInputType.Static,
  CertificateDynamicInputType.File,
];

export const DynamicInputIcons = {
  [CertificateDynamicInputType.Text]: 'text',
  [CertificateDynamicInputType.Image]: 'image',
  [CertificateDynamicInputType.Repeatable]: 'dual-arrow',
  [CertificateDynamicInputType.Object]: 'box',
  [CertificateDynamicInputType.Number]: 'relationship-count',
  [CertificateDynamicInputType.Static]: 'locked',
  [CertificateDynamicInputType.File]: 'form-file'
};

export const BuilderDynamicInputTypes = [
  CertificateDynamicInputType.Text,
  CertificateDynamicInputType.Image,
  CertificateDynamicInputType.Repeatable,
  CertificateDynamicInputType.Object,
]

export const EndPointDynamicInputTypes = [
  CertificateDynamicInputType.Text,
  CertificateDynamicInputType.Object,
  CertificateDynamicInputType.Number,
  CertificateDynamicInputType.Static,
]
